import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import Markdown, {} from 'markdown-to-jsx/react';
import designsystemtypography from '@helsenorge/designsystem-react/scss/typography.module.scss';
import { DEFAULT_MARKDOWN_OVERRIDES } from './markdown';
import { envSafeUrl } from './safe-html';
import { sanitize } from '../../trusted-types';
import ErrorBoundary from '../error-boundary';
import styles from './styles.module.scss';
const parseHtml = (html, type) => {
    if (typeof html === 'string' && type === 'markdown') {
        return {
            type: 'markdown',
            value: html,
        };
    }
    else if (typeof html === 'string') {
        return html;
    }
    if (html?.value) {
        return html;
    }
    return null;
};
const SafeHtmlString = ({ html, tagName, testId, className, ...rest }) => {
    const CustomTag = tagName || 'span';
    return (_jsx(CustomTag, { className: classNames(designsystemtypography['anchorlink-wrapper'], styles['safe-html'], className), "data-testid": testId, dangerouslySetInnerHTML: { __html: sanitize(envSafeUrl(html)) }, ...rest }));
};
const SafeHTML = ({ html, tagName, type, testId, className, markdownOverrides, ...rest }) => {
    const parsedHtml = parseHtml(html, type);
    if (!parsedHtml) {
        return null;
    }
    if (typeof parsedHtml === 'string') {
        return (_jsx(ErrorBoundary, { renderFallback: parsedHtml, children: _jsx(SafeHtmlString, { html: parsedHtml, tagName: tagName, testId: testId, className: className, ...rest }) }));
    }
    else {
        if (!parsedHtml?.value) {
            return null;
        }
        const CustomTag = tagName || 'div';
        return (_jsx(CustomTag, { className: classNames(styles['safe-html'], className), "data-testid": testId, children: _jsx(Markdown, { options: {
                    wrapper: React.Fragment,
                    overrides: {
                        ...DEFAULT_MARKDOWN_OVERRIDES,
                        ...markdownOverrides,
                    },
                }, children: envSafeUrl(parsedHtml.value) }) }));
    }
};
export default SafeHTML;
